import React from 'react'
import NavBar from '../components/NavBar'
import { Outlet } from 'react-router-dom'

const NavbarLayout = () => {
  return (
    <>
      <NavBar />
      <Outlet />
    </>
  )
}

export default NavbarLayout
